const PREFIX = 'EVENT'

export const EVENT_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const EVENT_LOADING_CATEGORIES_STATUS = `${PREFIX}_LOADING_CATEGORIES_STATUS`
export const EVENT_GET = `${PREFIX}_GET`
export const EVENTS_FETCH_CATEGORIES = `${PREFIX}_GET_CATEGORIES`
export const EVENTS_CLEAR = `${PREFIX}_CLEAR`
export const EVENTS_FETCH_CATEGORIES_ERROR = `${PREFIX}_GET_CATEGORIES_ERRORS`
export const EVENT_GET_ERROR = `${PREFIX}_GET_ERRORS`
export const EVENTS_FETCH = `${PREFIX}_FETCH`
export const EVENTS_FETCH_ERROR = `${PREFIX}_FETCH_ERRORS`
export const AGENDA_EVENT_GET = `AGENDA_${PREFIX}_GET`
export const EVENT_AGENDA_UPDATE_ITEM = `${PREFIX}_AGENDA_UPDATE_ITEM`
export const ATTENDEES_EVENT_GET = `ATTENDEES_${PREFIX}_GET`
export const ATTENDEE_EVENT_GET = `ATTENDEE_${PREFIX}_GET`
export const ATTENDEES_EVENT_CLEAR = `ATTENDREES_${PREFIX}_CLEAR`
export const REMOVE_ATTENDEES_EVENT = `ATTENDEES_${PREFIX}_REMOVE`
export const PARTNERS_EVENT_GET = `PARTNERS_${PREFIX}_GET`
export const SESSION_EVENT_GET = `SESSION_${PREFIX}_GET`
export const SESSION_EVENT_CLEAR = `SESSIONS_${PREFIX}_CLEAR`
export const SESSION_EVENT_QUESTIONS_GET = `SESSION_${PREFIX}_QUESTIONS_GET`
export const SESSION_EVENT_DELETE = `SESSION_${PREFIX}_DELETE`
export const SESSION_EVENT_DELETE_LOADING = `SESSION_${PREFIX}_DELETE_LOADING`
export const SESSION_EVENT_QUESTIONS_CLEAR = `SESSION_${PREFIX}_QUESTIONS_CLEAR`

export const EVENT_GET_TRACKS = `${PREFIX}_GET_TRACKS`
export const EVENT_TRACKS_LOADING_STATUS = `${PREFIX}_TRACKS_LOADING_STATUS`
export const EVENT_CLEAR_TRACKS = `${PREFIX}_CLEAR_TRACKS`

export const GET_ACTION_FILES = `${PREFIX}_GET_ACTION_FILES`
export const GET_ACTION_LINKS = `${PREFIX}_GET_ACTION_LINKS`

export const EVENT_MY_AGENDA_LOADING_STATUS = `${PREFIX}_MY_AGENDA_LOADING_STATUS`
export const EVENT_POLLS_LOADING_STATUS = `${PREFIX}_POLLS_LOADING_STATUS`
export const UPDATE_EVENT_POLLS = `UPDATE_${PREFIX}_POLLS`
export const EVENT_SPEAKERS_GET = `${PREFIX}_SPEAKER_GET`
export const EVENT_SPEAKERS_CLEAR = `${PREFIX}_SPEAKERS_CLEAR`

export const EVENT_RATINGS_LOADING_STATUS = `${PREFIX}_RATINGS_LOADING_STATUS`
export const UPDATE_EVENT_RATINGS = `UPDATE_${PREFIX}_RATINGS`
export const UPDATE_SESSION_RATINGS = `UPDATE_${PREFIX}_SESSION_RATINGS`

export const EVENT_GET_EXHIBITOR = `${PREFIX}_GET_EXHIBITOR`
export const EVENT_CLEAR_EXHIBITOR = `${PREFIX}_CLEAR_EXHIBITOR`
export const EVENT_GET_EXHIBITOR_ERROR = `${PREFIX}_GET_EXHIBITOR_ERROR`
export const SET_FOLLOW_STATUS = `${PREFIX}_SET_FOLLOW_STATUS`
export const SET_FOLLOW_NOTE = `${PREFIX}_SET_FOLLOW_NOTE`
export const DELETE_FOLLOW_NOTE = `${PREFIX}_DELETE_FOLLOW_NOTE`

export const GET_BOOT_STAFF_LIST = `${PREFIX}_GET_BOOT_STAFF_LIST`
export const BOOT_STAFF_LOADING_STATUS = `${PREFIX}_BOOT_STAFF_LOADING_STATUS`

export const POST_EVENT_SESSIONS_REGISTER = `${PREFIX}_EVENT_SESSIONS_REGISTER`
export const POST_EVENT_SESSIONS_REGISTER_LOADING = `${PREFIX}_EVENT_SESSIONS_REGISTER_LOADING`
export const DELETE_EVENTS_SESSIONS_REGISTER = `${PREFIX}_EVENTS_SESSIONS_REGISTER`

export const EVENT_PRIVATE_LOADING = `${PREFIX}_PRIVATE_LOADING`

export const GET_SUB_SESSIONS = `${PREFIX}_GET_SUB_SESSIONS`
export const GET_SUB_SESSIONS_LOADING = `${PREFIX}_GET_SUB_SESSIONS_LOADING`
export const GET_SUB_SESSIONS_ERROR = `${PREFIX}_GET_SUB_SESSIONS_ERROR`

export const GET_SESSIONS_SPEAKERS_LIST = `${PREFIX}_GET_SESSIONS_SPEAKERS_LIST`
export const GET_SESSIONS_SPEAKERS_LIST_LOADING = `${PREFIX}_GET_SESSIONS_SPEAKERS_LIST_LOADING`
export const GET_SESSIONS_SPEAKERS_LIST_ERROR = `${PREFIX}_GET_SESSIONS_SPEAKERS_LIST_ERROR`

export const GET_SURVEY = `${PREFIX}_GET_SURVEY`
export const GET_SURVEY_LOADING = `${PREFIX}_GET_SURVEY_LOADING`
export const GET_SURVEY_ERROR = `${PREFIX}_GET_SURVEY_ERROR`

export const POST_SURVEY_CLASSIC = `${PREFIX}_POST_SURVEY_CLASSIC`
export const POST_SURVEY_CLASSIC_LOADING = `${PREFIX}_POST_SURVEY_CLASSIC_LOADING`
export const POST_SURVEY_CLASSIC_ERROR = `${PREFIX}_POST_SURVEY_CLASSIC_ERROR`

export const GET_PARTNER_FILES = `${PREFIX}_GET_PARTNER_FILES`
export const GET_PARTNER_FILES_LOADING = `${PREFIX}_GET_PARTNER_FILES_LOADING`
export const GET_PARTNER_FILES_ERROR = `${PREFIX}_GET_PARTNER_FILES_ERROR`

export const GET_GIVEAWAYS = `${PREFIX}_GET_GIVEAWAYS`
export const GET_GIVEAWAYS_LOADING = `${PREFIX}_GET_GIVEAWAYS_LOADING`
export const GET_GIVEAWAYS_ERROR = `${PREFIX}_GET_GIVEAWAYS_ERROR`
export const GET_GIVEAWAYS_ERROR_CLEAR = `${PREFIX}_GET_GIVEAWAYS_ERROR_CLEAR`

export const GET_DATE_LIST_EVENTS = `${PREFIX}_GET_DATE_LIST_EVENTS`
export const GET_DATE_LIST_LOADING = `${PREFIX}_GET_DATE_LIST_LOADING`
export const GET_DATE_LIST_ERROR = `${PREFIX}_GET_DATE_LIST_ERROR`

export const GET_SPEAKER_FILTER_LIST = `${PREFIX}_GET_SPEAKER_FILTER_LIST`
export const GET_SPEAKER_FILTER_LOADING = `${PREFIX}_GET_SPEAKER_FILTER_LOADING`
export const GET_SPEAKER_FILTER_LIST_ERROR = `${PREFIX}_GET_SPEAKER_FILTER_LIST_ERROR`
export const GET_SPEAKER_FILTER_CLEAR = `${PREFIX}_GET_SPEAKER_FILL_CLEAR`

